import React from "react";
import { Box, Typography } from "@mui/material";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

export default function AdminContent({ path }) {
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				maxWidth: 260,
				padding: "10px 30px",
				textAlign: "center",
				transform: "translateY(-20px)",
				position: "relative",
				zIndex: 10,
			}}
		>
			<Typography
				sx={{ fontSize: 10, backgroundColor: "#d9f5ed", borderRadius: 8 }}
			>
				{t("general.testContent1")}
				<br />
				{t("general.testContent2")}{" "}
				<span
					onClick={() => {
						ReactGA.event({
							category: "link",
							action: "click",
							label: "Go to admin",
						});
						window.location.href =
							(window.location.hostname === "127.0.0.1"
								? "http://127.0.0.1:3001" + path
								: window.location.hostname === "localhost"
								? "http://localhost:3001" + path
								: "https://admin.applaby.com" + path) +
							(localStorage.getItem("token")
								? "?session=" + localStorage.getItem("token")
								: "");
					}}
					style={{ fontWeight: 700, color: "#43bd98", cursor: "pointer" }}
				>
					{t("general.testContent3")}
				</span>
			</Typography>
		</Box>
	);
}
